<template>
  <div class="view pa24">
    <el-dialog
        :title="title"
        width="800px"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="closeDialog"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="dealerRuleForm"
          label-width="100px"
          class="ruleForm"
      >

        <el-form-item label="分公司名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addOrUpdateBranchCompany} from '@/api/branchCompany.js'


export default {
  name: "productList",
  components: {
    // BaiduMap,
    // Map
  },
  props: [],

  data() {
    return {
      dialogVisible: false,
      title: '添加分公司',
      ruleForm: {
        name: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入分公司名称', trigger: 'blur'},
        ],
      },
      type: 'add',
      id: '',

    };
  },
  onShow() {

  },
  methods: {
    openDialog(type, data, source) {
      this.source = source
      this.dialogVisible = true
      let v = this
      if (type === 'add') {
        this.title = '添加分公司'
        this.type = 'add'
        this.id = ''
        this.ruleForm.name = ''
      } else {
        this.title = '编辑分公司'
        this.getData(data)
        this.type = "edit"
        this.id = data.id
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.resetForm()
      this.$emit('getList')
    },
    resetForm() {
      this.$refs.dealerRuleForm.resetFields();
    },
    confirmAddDealer() {
      this.$refs.dealerRuleForm.validate((valid) => {
        if (valid) {
          // this.getCity(this.ruleForm.coordinate.lng, this.ruleForm.coordinate.lat).then(res => {
            let params = {
              name: this.ruleForm.name,
            }
            if (this.type === 'edit') {
              params.id = this.id
            }
          addOrUpdateBranchCompany(params).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.closeDialog()
              }
            })
        }
      })
    },
    // 回显
    getData(data) {
      this.ruleForm.name = data.name
    }
  },
};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10 rpx;
}
</style>
